document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('levCart');
  const form = document.getElementById('levCartForm');
  if (!root || !form) return;
  const session = window.LevCartSession;
  const messages = document.documentElement.dataset;
  const cartRoot = window.Shopify?.routes?.root || '/';
  let stale = false;
  const status = document.createElement('p');
  status.dataset.cartStatus = '';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  root.querySelector('h1')?.after(status);
  const showStatus = (message, review = false) => {
    status.textContent = message;
    if (review) {
      const link = document.createElement('a');
      link.href = cartRoot + 'cart';
      link.textContent = messages.cartView;
      status.append(' ', link);
    }
  };
  const quantity = value => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : null;
  async function change(key, amount) {
    if (stale) return;
    if (!key || amount === null || amount < 0) {
      showStatus(messages.cartInvalidQuantity);
      return;
    }
    const token = session?.begin();
    if (!token) {
      showStatus(messages.cartUncertain, true);
      return;
    }
    root.setAttribute('aria-busy', 'true');
    showStatus(messages.cartUpdating);
    try {
      const response = await fetch(cartRoot + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: amount }), signal: AbortSignal.timeout(20000),
      });
      if (!response.ok || !session.isCart(await response.json())) throw new Error('Cart change requires review');
      // Keep the lock until the document is replaced; its inputs are now stale.
      window.location.reload();
    } catch (error) {
      session.finish(token, false);
      root.setAttribute('aria-busy', 'false');
      showStatus(messages.cartUncertain, true);
    }
  }
  root.addEventListener('click', event => {
    const remove = event.target.closest('[data-remove]');
    if (remove) { change(remove.dataset.remove, 0); return; }
    const step = event.target.closest('[data-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const current = quantity(input?.value);
    change(input?.dataset.key, current === null ? null : current + Number(step.dataset.step));
  });
  root.addEventListener('change', event => {
    if (event.target.matches('input[name="updates[]"]')) change(event.target.dataset.key, quantity(event.target.value));
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (stale || !session || session.blocked()) return;
    const edited = [...form.querySelectorAll('input[name="updates[]"]')].find(input => input.value !== input.defaultValue);
    if (edited) { change(edited.dataset.key, quantity(edited.value)); return; }
    // Do not post stale positional updates when the user only requested checkout.
    window.location.href = cartRoot + 'checkout';
  });
  document.addEventListener('lev:cart-updated', () => { stale = true; window.location.reload(); });
});
